import {AbbreviationMap} from './abbreviationProcessor';

export const parseFootnotes = (footnotesContent: string): AbbreviationMap => {
  const footnoteMap: AbbreviationMap = {};

  if (!footnotesContent) {
    return footnoteMap;
  }

  // Regex pattern to match footnotes in format: [1] content\n[2] content...
  // Pattern breakdown:
  // \s*             - Match optional leading whitespace
  // \[(\d+)\]       - Match opening bracket, capture one or more digits (footnote number), closing bracket
  // \s*             - Match optional whitespace after the bracket
  // (.*?)           - Capture any characters (footnote content), non-greedy
  // (?=\n\s*\[\d+\]|$) - Positive lookahead: stop when we encounter newline followed by optional whitespace and next footnote [digits] OR end of string
  // Flags:
  // g - Global: find all matches
  // s - Dotall: allow '.' to match newlines (so content can span multiple lines)
  const footnoteRegex = /\s*\[(\d+)\]\s*(.*?)(?=\n\s*\[\d+\]|$)/gs;
  
  
  let match;
  while ((match = footnoteRegex.exec(footnotesContent)) !== null) {
    const footnoteNumber = match[1];
    const footnoteContent = match[2].trim();

    footnoteMap[`[${footnoteNumber}]`] = footnoteContent;
  }
  return footnoteMap;
};

